module.exports = __webpack_public_path__ + "img/page-bg-en.cb65afe3.png";